var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterHoursReferralRules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.019,
    cy: 38.881,
    r: 2.684,
    className: "stroke fill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M29.019 18.252v17.945m27.425 4.461c-.918 14.341-12.855 25.704-27.425 25.704-15.167 0-27.481-12.314-27.481-27.481S13.852 11.4 29.019 11.4a27.35 27.35 0 0 1 16.639 5.614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M73.462 32.882c-2.801 4.658-7.904 7.776-13.73 7.776-8.836 0-16.011-7.174-16.011-16.01s7.175-16.01 16.011-16.01h.018a15.34 15.34 0 0 0-2.812 8.873c0 8.505 6.905 15.411 15.411 15.411q.563 0 1.113-.04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M29.019 61.622v-2.38M8.265 38.881h-2.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterHoursReferralRules);
export default __webpack_public_path__ + "static/media/after-hours-referral-rules.6617e23e7a2f0a1349f4fb65fa435d8d.svg";
export { ForwardRef as ReactComponent };